module.exports = __webpack_public_path__ + "static/media/2.4f532485.jpg";